import { Injectable } from '@angular/core';
import {AppConfigService} from '../config/app-config.service';

declare let gtag: Function;

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {

  constructor(protected config: AppConfigService) { }

  public trackPage(pagePath: string , pageTitle?: string): void {
    if (this.config.annalyticsConfig) {
      gtag('config', this.config.annalyticsConfig.analyticsGoogleID,
        {
          'page_title': pageTitle,
          'page_path': pagePath
        }
      );
    } else {
      console.error("Brak konfiguracji dla google analytics");
    }
  }

  public trackSearchTerms(searchTerm: string ): void {
    gtag('event', 'search', {
      search_term: searchTerm,
    });
  }
}
